import { ServiceEnum } from "config/service";
import moment from "moment";
//Convert a SafePlacePatient to myLab patient
export const convertSafeplacePatientToMyLab = (patient) => {
	const newPatient = {
		...patient,
		birth_date: patient.birth_date && patient.birth_date.toString().length > 0 ? moment(patient.birth_date).format("YYYY-MM-DD") : null,
		mobile_phone: patient.mobilephone || patient.mobile_phone,
		gender: patient.gender === "male" || patient.gender === "m" || patient.gender === "M" ? "m" : "f",
		marital_name: patient.marital_name,
		married_name: patient.marital_name,
		identification: patient.identity_number,
		health_fund_id: patient.specialRegime ? patient.specialRegime.geslab_id : null,
	};
	return newPatient;
};
export const convertSafePlaceResultToPatient = (patient) => {
	let result = {
		birth_name: patient.birth_name ? patient.birth_name.toUpperCase() : "",
		birth_date: moment(patient.birth_date).format("YYYY-MM-DD"),
		last_name: patient.last_name ? patient.last_name.toUpperCase() : "",
		first_name: patient.first_name ? capitalize(patient.first_name) : "",
		marital_name: patient.last_name && patient.last_name !== patient.birth_name ? patient.last_name.toUpperCase() : "",
		matricule: patient.matricule,
		cns:
			patient.matricule && patient.matricule !== ""
				? patient.matricule
				: patient.birth_date && patient.birth_date !== ""
				? patient.birth_date.replaceAll("-", "")
				: "",
		gender: patient.gender === "male" || patient.gender === "m" ? "m" : "f",
		mobile_phone: patient.mobilephone || patient.mobile_phone.replace("+", "00"),
		mylab_id: patient.mylab_id || 0,
		email: patient.email,
		identification: patient.identity_number,
		identity_number: patient.identity_number,
		phone_comment: patient.phone_info,
		mobile_phone_comment: patient.mobile_phone_info,
		mobile_phone_is_relative: patient.mobile_phone_is_relative,
		email_comment: patient.email_info,
		post_it: patient.observation,
	};
	return result;
};

// Convert a myLabNurse patient to a myLab patient
export const convertPatientToMyLab = (patient) => {
	const newPatient = {
		...patient,
		id:
			patient.mylab_id ??
			(patient.externalIds && patient.externalIds.length > 0 && patient.externalIds.some((e) => e.service === ServiceEnum.mylab)
				? patient.externalIds.filter((e) => e.service === ServiceEnum.mylab)[0].external_id
				: patient.id),
		mylab_id:
			patient.mylab_id ??
			(patient.externalIds && patient.externalIds.length > 0 && patient.externalIds.some((e) => e.service === ServiceEnum.mylab)
				? patient.externalIds.filter((e) => e.service === ServiceEnum.mylab)[0].external_id
				: null),
		birth_date: patient.birth_date && patient.birth_date.toString().length > 0 ? moment(patient.birth_date).format("YYYY-MM-DD") : null,
		addresses: {
			home: {
				number: patient.home_number,
				complement: patient.home_complement,
				street: patient.home_street,
				country: patient.home_country,
				city: patient.home_city,
				zip_code: patient.home_postal_code,
			},
			work: {
				company: patient.work_company,
				number: patient.work_number,
				complement: patient.work_complement,
				street: patient.work_street,
				country: patient.work_country,
				city: patient.work_city,
				zip_code: patient.work_postal_code,
			},
		},
	};
	newPatient.mobile_phone_info = patient.mobile_phone_comment;
	newPatient.observation = patient.post_it;
	newPatient.email_info = patient.email_comment;
	newPatient.phone_info = patient.phone_comment;
	newPatient.family_doctor_id = patient.doctor ? patient.doctor.mylab_id : null;
	newPatient.language = patient.languages ? patient.languages.map((l) => l.language).join(", ") : "";
	newPatient.health_fund_id = patient.specialRegime ? patient.specialRegime.geslab_id : null;

	newPatient.marital_name = patient.married_name;

	newPatient.last_name = `${patient.birth_name}${newPatient.marital_name && newPatient.marital_name !== "" ? ` ${newPatient.marital_name}` : ""}`;
	newPatient.gender = ["f", "m"].includes(patient.gender)
		? patient.gender
		: patient.gender === "female"
		? "f"
		: patient.gender === "male"
		? "m"
		: "o";
	return newPatient;
};

// Convert a myLab patient to a myLabNurse patient
export const convertMyLabToPatient = (myLabPatient) => {
	const newPatient = {
		...myLabPatient,
		sil_id: myLabPatient.lis_id,
		identification: myLabPatient.identification ?? myLabPatient.identity_number,
		gender: myLabPatient.gender === "male" ? "m" : myLabPatient.gender === "female" ? "f" : myLabPatient.gender,
		home_number: myLabPatient.addresses?.home?.number ?? null,
		home_complement: myLabPatient.addresses?.home?.complement ?? null,
		home_street: myLabPatient.addresses?.home ? removeNumberFromStreet(myLabPatient.addresses.home.number, myLabPatient.addresses.home.street) : null,
		home_country: myLabPatient.addresses?.home?.country ?? myLabPatient.addresses?.home?.country_iso ?? null,
		home_city: myLabPatient.addresses?.home?.city ?? null,
		home_postal_code: myLabPatient.addresses?.home?.zip_code ?? myLabPatient.addresses?.home?.postal_code ?? null,
		work_company: myLabPatient.addresses?.work?.company ?? null,
		work_number: myLabPatient.addresses?.work?.number ?? null,
		work_complement: myLabPatient.addresses?.work?.complement ?? null,
		work_street: myLabPatient.addresses?.work ? removeNumberFromStreet(myLabPatient.addresses.work.number, myLabPatient.addresses.work.street) : null,
		work_country: myLabPatient.addresses?.work?.country ?? null,
		work_city: myLabPatient.addresses?.work?.city ?? null,
		work_postal_code: myLabPatient.addresses?.work?.zip_code ?? myLabPatient.addresses?.work?.postal_code ?? null,
		mylab_is_active: myLabPatient.active,
		phone_comment: myLabPatient.phone_info,
		mobile_phone_comment: myLabPatient.mobile_phone_info,
		mobile_phone_is_relative: myLabPatient.mobile_phone_is_relative,
		email_comment: myLabPatient.email_info,
		post_it: myLabPatient.observation,
		languages: myLabPatient.communication_language
			? myLabPatient.communication_language.split(",").map((lang) => {
					return { language: lang.toLowerCase() };
			  })
			: [],
		patientInsurances: [],
		specialRegime: { geslab_id: myLabPatient.health_fund_id },
		mylab_id: myLabPatient.id ?? myLabPatient.mylab_id,
		married_name: myLabPatient.marital_name,
		first_name: myLabPatient.first_name ?? myLabPatient.firstname,
		updated_at: myLabPatient.updated_at ?? myLabPatient.last_update,
		externalIds: myLabPatient.externalIds ?? [
			{
				id: myLabPatient.externalIds?.find((extId) => extId.service.id === ServiceEnum.mylab)?.id,
				external_id: myLabPatient.id ?? myLabPatient.mylab_id,
				service: ServiceEnum.mylab,
			},
		],
		doctor: myLabPatient.family_doctor ? convertFamilyDoctorToDoctor(myLabPatient.family_doctor) : null,
		litigation: myLabPatient.disputes,
	};
	if (myLabPatient.birthdate) newPatient.birth_date = moment(myLabPatient.birthdate).format("YYYY-MM-DD");
	if (myLabPatient.birth_date) newPatient.birth_date = moment(myLabPatient.birth_date).format("YYYY-MM-DD");
	if (myLabPatient.insurance1_id)
		newPatient.patientInsurances.push({
			insurance: {
				id: parseInt(myLabPatient.insurance1_id),
				value: parseInt(myLabPatient.insurance1_id),
			},
			number: myLabPatient.insurance1_number,
		});
	if (myLabPatient.insurance2_id)
		newPatient.patientInsurances.push({
			insurance: myLabPatient.insurance2_id
				? {
						id: parseInt(myLabPatient.insurance2_id),
						value: parseInt(myLabPatient.insurance2_id),
				  }
				: null,

			number: myLabPatient.insurance2_number,
		});

	if (myLabPatient.address) {
		newPatient.home_country = myLabPatient.address.country === "LUX" ? "LU" : myLabPatient.address.country;
		newPatient.home_city = myLabPatient.address.city;
		newPatient.home_postal_code = myLabPatient.address.postal_code;
		newPatient.home_street = myLabPatient.address.street;
	}

	delete newPatient.id;
	return newPatient;
};

export const convertFamilyDoctorToDoctor = (myLabFamilyDoctor) => {
	const newDoctor = {
		...myLabFamilyDoctor,
		mylab_id: myLabFamilyDoctor.id,
		last_name: myLabFamilyDoctor.medical_staff ? myLabFamilyDoctor.medical_staff.lastname : myLabFamilyDoctor.office_name,
		first_name: myLabFamilyDoctor.medical_staff ? myLabFamilyDoctor.medical_staff.firstname : " ",
		title: myLabFamilyDoctor.medical_staff ? myLabFamilyDoctor.medical_staff.title : " ",
		code: myLabFamilyDoctor.medical_staff ? myLabFamilyDoctor.medical_staff.provider_code : " ",
		number: myLabFamilyDoctor.address ? myLabFamilyDoctor.address.number : null,
		street: myLabFamilyDoctor.address ? myLabFamilyDoctor.address.street : null,
		complement: myLabFamilyDoctor.address ? myLabFamilyDoctor.address.complement : null,
		country: myLabFamilyDoctor.address ? myLabFamilyDoctor.address.country_iso : null,
		city: myLabFamilyDoctor.address ? myLabFamilyDoctor.address.city : null,
		postal_code: myLabFamilyDoctor.address ? myLabFamilyDoctor.address.postal_code : null,
		auto_free_prescription: myLabFamilyDoctor.auto_free_prescription ?? false,
	};
	delete newDoctor.id;
	return newDoctor;
};

// Convert a myLab patient from a scan to a myLabNurse patient
export const convertMyLabScanToPatient = (myLabPatient) => {
	const newPatient = {
		...myLabPatient,
		gender: myLabPatient.gender === "male" ? "m" : myLabPatient.gender === "female" ? "f" : myLabPatient.gender,
		sil_id: myLabPatient.lis_id,
		home_number: myLabPatient.address?.number ?? null,
		home_complement: myLabPatient.address?.complement ?? null,
		home_street: myLabPatient.address ? removeNumberFromStreet(myLabPatient.address.number, myLabPatient.address.street) : null,
		home_country: myLabPatient.address?.country ?? null,
		home_city: myLabPatient.address?.city ?? null,
		home_postal_code: myLabPatient.address?.postal_code ?? null,
		mylab_is_active: myLabPatient.active,
		phone_comment: myLabPatient.phone_info,
		mobile_phone_comment: myLabPatient.mobile_phone_info,
		mobile_phone_is_relative: myLabPatient.mobile_phone_is_relative,
		email_comment: myLabPatient.email_info,
		post_it: myLabPatient.observation,
		languages: myLabPatient.communication_language
			? myLabPatient.communication_language.split(",").map((lang) => {
					return { language: lang.toLowerCase() };
			  })
			: [],
		patientInsurances: [],
		specialRegime: { geslab_id: myLabPatient.health_fund_id },
		externalIds: myLabPatient.externalIds
			? [
					{
						id: myLabPatient.externalIds?.find((extId) => extId.service.id === ServiceEnum.mylab)?.id,
						external_id: myLabPatient.mylab_id,
						service: ServiceEnum.mylab,
					},
			  ]
			: [],
	};
	if (myLabPatient.insurance1_id)
		newPatient.patientInsurances.push({
			insurance: {
				id: parseInt(myLabPatient.insurance1_id),
				value: parseInt(myLabPatient.insurance1_id),
			},
			number: myLabPatient.insurance1_number,
		});
	if (myLabPatient.insurance2_id)
		newPatient.patientInsurances.push({
			insurance: myLabPatient.insurance2_id
				? {
						id: parseInt(myLabPatient.insurance2_id),
						value: parseInt(myLabPatient.insurance2_id),
				  }
				: null,

			number: myLabPatient.insurance2_number,
		});

	return newPatient;
};

// Convert a patient for the patient matcher
export const convertForPatientMatcher = (patient) => {
	const query = {
		first_name: patient.first_name || patient.firstname,
		birth_name: patient.birth_name || patient.birthname || patient.last_name || patient.lastname,
		married_name: patient.birth_name !== patient.last_name ? patient.last_name : null,
		email: patient.email,
		birth_date: patient.birth_date || patient.birthdate,
		cns: patient.cns || patient.matricule,
	};

	return query;
};

export const removeNumberFromStreet = (number, street) => {
	let cleanedStreet = street;
	if (cleanedStreet) {
		if (number && cleanedStreet.startsWith(number)) {
			cleanedStreet = cleanedStreet.replace(number, "");
			if (cleanedStreet.startsWith(",")) cleanedStreet = cleanedStreet.replace(",", "");
		}
		cleanedStreet = cleanedStreet.trim();
	}
	return cleanedStreet;
};

//Only works with an address which starts with a number
//Works -> 120 Langstrasse
//Doesn't work -> Langstrasse 120
export const findNumberInAddress = (address) => {
	let a = address.trim().split(" "),
		number;

	if (a.length <= 1) return null;

	if (isNumber(a[0].substr(0, 1)) || isFractionalChar(a[0].substr(0, 1))) {
		number = a.shift();
	} else {
		return null;
	}
	if (/[0-9]\/[0-9]/.exec(a[0]) || indexFractionalChar(a[0]) !== false) number += " " + a.shift();

	//Remove coma after number
	number = number.replace(/,\s*$/, "");
	return number;
};

const isNumber = (n) => {
	return !isNaN(parseFloat(n)) && isFinite(n);
};

const isFractionalChar = (n) => {
	const c = n.charCodeAt();
	return (c >= 188 && c <= 190) || (c >= 8531 && c <= 8542);
};

const indexFractionalChar = (m) => {
	let a = m.split(""),
		i;
	for (i in a) {
		if (isFractionalChar(a[i])) return i;
	}

	return false;
};

export const capitalize = (str) => {
	if (typeof str !== "string") return "";
	return str
		.split(" ")
		.map((s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
		.join(" ");
};

export const convertPreregisterResultToPatient = (patient) => {
	let result = {
		birth_name: patient.birth_name ? patient.birth_name.toUpperCase() : "",
		birth_date: patient.birth_date,
		last_name: patient.last_name ? patient.last_name.toUpperCase() : "",
		first_name: patient.first_name ? capitalize(patient.first_name) : "",
		marital_name: patient.birth_name !== patient.last_name && patient.last_name ? patient.last_name.toUpperCase() : "",
		matricule: patient.matricule,
		cns:
			patient.matricule && patient.matricule !== ""
				? patient.matricule
				: patient.birth_date && patient.birth_date !== ""
				? patient.birth_date.replaceAll("-", "")
				: "",
		gender: patient.gender === "male" || patient.gender === "m" ? "m" : "f",
		mobile_phone: patient.mobile_phone,
		mylab_id: patient.mylab_id,
		email: patient.email,
		identification: patient.identity_number,
		identity_number: patient.identity_number,
		phone_comment: patient.phone_info,
		mobile_phone_comment: patient.mobile_phone_info,
		mobile_phone_is_relative: patient.mobile_phone_is_relative,
		email_comment: patient.email_info,
		post_it: patient.observation,
	};
	return result;
};
